import React, {useRef, useState} from 'react';
import FileService from "../../service/FileService";
import {ReactCrop} from "react-image-crop";
import 'react-image-crop/dist/ReactCrop.css'
import {InputText} from "primereact/inputtext";
import VideoPlayer from "../videoPlayer/VideoPlayer";
import { getFrame } from "../../utils/VideoToFrame";
import {Dialog} from "primereact/dialog";
import CoursePreview from "../courseCurriculum/CoursePreview";
import ReactPlayer from "react-player";

const playIcon = "/icons/play.png";

// const defaultData={
//     name: '',
//     file: null,
//     preview: null
// }
const FileUploader = (props) => {
    const {name, type, label, onUpload, accept} = props;
    const [src, setSrc] = useState(props.src);
    const [file, setFile] = useState(props.file);
    const [displayDialog, setDisplayDialog] = useState(false);
    // const [data, setData] = useState(defaultData);
    // const [previewFile, setPreviewFile] = useState(props.preview);

    const [crop, setCrop] = useState({
        unit: 'px', // Can be 'px' or '%'
        x: 0,
        y: 0,
        width: 750,
        height: 422
    })

    const refUploadInput = useRef(null);

    const fileService = new FileService();

    const handleUploadFile = async (event) => {
        let file = event.target.files[0];
        if(type=== "video"){
            file.duration = await getDuration(URL.createObjectURL(file));
            console.log(file);
            setSrc(await getFrame(URL.createObjectURL(file)))
        }
        setFile(file);
        onUpload(file);
    };


    const getDuration = async(url)=> {
        return new Promise((resolve) => {
            const audio = document.createElement("audio");
            audio.muted = true;
            const source = document.createElement("source");
            source.src = url; //--> blob URL
            audio.preload= "metadata";
            audio.appendChild(source);
            audio.onloadedmetadata = function(){
                resolve(audio.duration)
            };
        });
    }

    // const handleUploadFile = (event) => {
    //     const data = new FormData();
    //     //using File API to get chosen file
    //     let file = event.target.files[0];
    //     setFile(file);
    //     // console.log("Uploading file", event.target.files[0]);
    //     data.append('file', event.target.files[0]);
    //     data.append('name', event.target.files[0].name);
    //     // data.append('description', 'this file is uploaded by young padawan');
    //     //calling async Promise and handling response or error situation
    //
    //     let reader = new FileReader();
    //
    //     reader.onloadend = () => {
    //         data.append('preview', reader.result);
    //         setPreviewFile(reader.result);
    //     }
    //
    //     reader.readAsDataURL(file)
    //
    //     setData(data);
    //
    //     onUpload(data);
    //
    //     // this.fileService.upload(data);
    // };

    // const setDataByName =(name)=>{
    //     if(!GeneralUtils.isNullOrEmpty(name)) {
    //         fileService.getFileByName(name).then(result => setImagePreviewUrl(result));
    //     }
    // }
    // const getData =()=>{
    //     return data;
    // }
    //
    // const clearData =()=>{
    //     refUploadInput.value = null;
    //     setData(null);
    //     setFile(null);
    //     setImagePreviewUrl(null);
    // }

    const getPreviewFile = () => {
        if (type === "image") {
            return <>
            {/*<ReactCrop crop={crop} onChange={c => {*/}
            {/*        console.log(c);*/}
            {/*        setCrop(c)*/}
            {/*    }}*/}
            {/*               // keepSelection*/}
            {/*               // minWidth="750"*/}
            {/*               // minHeight="422"*/}
            {/*    >*/}
                    <img src={file ? URL.createObjectURL(file) : src ? src : ""} alt="" style={{width: "450px"}}
                         // onError={(e) => e.target.src = "/assets/images/placeholderImage.jpg"}
                    />
                {/*</ReactCrop>*/}
            </>
        } else {
            return <>
                <div className="video-gallery" style={{width: "450px", cursor: "pointer"}} onClick={() => setDisplayDialog(true)}>
                    <div className="thumbnail">
                        <img src={src} alt="" style={{width: "450px", borderRadius: "10px !important"}}
                             onError={(e) => e.target.src = "/assets/images/placeholderImage.jpg"}
                        />
                        <button onClick={() => setDisplayDialog(true)}
                                className="video-play-btn video-popup-activation">
                            <i className="icon-18"></i>
                        </button>
                    </div>
                </div>
                <Dialog header={file ? file.name : ""} visible={displayDialog}
                        onHide={() => setDisplayDialog(false)} position='top' style={{width: '40vw'}}>
                    <ReactPlayer url={file ? URL.createObjectURL(file) : src ? src : ""}
                                 width='100%'
                                 height='100%' controls/>
                </Dialog>

                {/*<div style={{width: "450px", cursor: "pointer"}} onClick={() => setDisplayDialog(true)}>*/}
                {/*    /!*<video*!/*/}
                {/*    /!*    className="VideoInput_video"*!/*/}
                {/*    /!*    width="100%"*!/*/}
                {/*    /!*    controls*!/*/}
                {/*    /!*    src={file ? URL.createObjectURL(file) : src ? src : ""}/>*!/*/}
                {/*    /!*<VideoPlayer url={file ? URL.createObjectURL(file) : src ? src : ""} playerFullWidth*!/*/}
                {/*    /!*             light={<img src="/assets/images/placeholderImage.jpg" alt="" width="100%"/>}/>*!/*/}
                {/*    <img src={src} alt="" style={{width: "450px"}}*/}
                {/*         onError={(e) => e.target.src = "/assets/images/placeholderImage.jpg"}/>*/}
                {/*</div>*/}
            </>
        }
    }

    return (
        <div className="flex flex-row gap-2 ">
            <div className="grid">
                <div className="col">
                    {file || src ? getPreviewFile() :
                        <img src="/assets/images/placeholderImage.jpg" alt="" width="450"/>}
                </div>
                <div className="col">
                    <p>{label}</p>

                    {/*<label id={`${name}-label`} htmlFor={name}*/}
                    {/*       className="p-component p-button p-component p-fileupload-choose"><i className="pi pi-plus"/> Dosya Yükle</label>*/}

                    <label id={`${name}-label`} htmlFor={name} className="p-component">
                        <div className="p-inputgroup flex-1" htmlFor={name}>
                                    <InputText placeholder="Seçili dosya yok" disabled value={file ? file.name : ""}/>
                                    <div className="p-button p-component p-fileupload-choose"><i
                                        className="pi pi-plus"/> {file ? "Değiştir" : "Dosya Yükle"}</div>
                                </div>
                            </label>
                            <input name={name} id={name} type="file" style={{visibility: "hidden"}} ref={refUploadInput}
                                   accept={accept} onChange={handleUploadFile}/>
                        </div>
                    </div>
                </div>
                )
                }
                export default FileUploader;
